import React from 'react'
import HeaderComp from './HeaderComp/HeaderComp'
import HeaderComp1 from './HeaderComp1/HeaderComp1'
import NavbarComp from './NavBarComp/NavbarComp'
import styled from 'styled-components'
import NavBarSearchBar from './NavBarSearchBar'

const Header = () => {
  return (
    <Wrapper >
        <HeaderComp/>
        <HeaderComp1/>
        <NavbarComp/> 
        <NavBarSearchBar/>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
`;

export default Header
